/**
 * AdminApp — platform admin single-page app.
 *
 * Mounted at /admin/* by main.tsx (URL path check).
 *
 * Routes:
 *   /admin               → redirect to /admin/dashboard
 *   /admin/dashboard     → AdminDashboard (platform stats)
 *   /admin/accounts      → AdminAccounts (paginated tenant list)
 *   /admin/accounts/:id  → AdminAccountDetail
 *   /admin/provision     → AdminProvision (new tenant form)
 *   /login               → redirects to the staff login page
 */

import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AdminGate } from './AdminGate';
import { AdminShell } from './AdminShell';
import { AdminAccountDetail } from './pages/AdminAccountDetail';
import { AdminAccounts } from './pages/AdminAccounts';
import { AdminDashboard } from './pages/AdminDashboard';
import { AdminProvision } from './pages/AdminProvision';
import { AdminAuthProvider } from './useAdminAuth';

export function AdminApp() {
  return (
    <BrowserRouter>
      <AdminAuthProvider>
        <Routes>
          {/* Redirect /login to the staff login page (shared auth) */}
          <Route path="/login" element={<Navigate to="/login" replace />} />

          {/* All admin routes require admin auth */}
          <Route
            path="/admin"
            element={
              <AdminGate>
                <AdminShell>
                  <Navigate to="/admin/dashboard" replace />
                </AdminShell>
              </AdminGate>
            }
          />
          <Route
            path="/admin/dashboard"
            element={
              <AdminGate>
                <AdminShell>
                  <AdminDashboard />
                </AdminShell>
              </AdminGate>
            }
          />
          <Route
            path="/admin/accounts"
            element={
              <AdminGate>
                <AdminShell>
                  <AdminAccounts />
                </AdminShell>
              </AdminGate>
            }
          />
          <Route
            path="/admin/accounts/:id"
            element={
              <AdminGate>
                <AdminShell>
                  <AdminAccountDetail />
                </AdminShell>
              </AdminGate>
            }
          />
          <Route
            path="/admin/provision"
            element={
              <AdminGate>
                <AdminShell>
                  <AdminProvision />
                </AdminShell>
              </AdminGate>
            }
          />

          {/* Unknown /admin/* routes → dashboard */}
          <Route path="/admin/*" element={<Navigate to="/admin/dashboard" replace />} />
        </Routes>
      </AdminAuthProvider>
    </BrowserRouter>
  );
}
